/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import2 from 'angular2-spinner/dist/angular2-spinner';
import * as import3 from '@angular/common';
import * as import4 from 'ngx-pagination';
import * as import5 from '../../../$$_gendir/node_modules/ngx-pagination/dist/ngx-pagination.ngfactory';
import * as import6 from '../../../$$_gendir/node_modules/ngx-modal/Modal.ngfactory';
import * as import7 from 'ngx-modal/Modal';
import * as import8 from '../../../app/shared/directives/clipboard.directive';
import * as import9 from 'angular2-notifications/src/notifications.service';
import * as import10 from '../../../app/vm/vm-dashboard.component';
import * as import11 from '../../../app/services/api.service';
import * as import12 from '../../../app/services/response.service';
import * as import13 from '@angular/router';
import * as import14 from 'ng2-breadcrumb/app/components/breadcrumbService';
const styles_VMDashboardComponent:any[] = ([] as any[]);
export const RenderType_VMDashboardComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_VMDashboardComponent,
  data: {}
}
);
function View_VMDashboardComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.powerVM('reboot',import0.ɵnov((<any>v.parent),26))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zrestartuj Cloud.VPS']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.checkingStatus;
    ck(v,0,0,currVal_0);
  });
}
function View_VMDashboardComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner center-v-h'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie danych Cloud.VPS'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_VMDashboardComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-medium btn-success btn-outline-success'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.goToBuyServices()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        Dokup usługi\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-medium'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.newMessage()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        Zgłoś awarię\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_VMDashboardComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' GB '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.disk_size;
    ck(v,1,0,currVal_0);
  });
}
function View_VMDashboardComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'Adres główny: ',
      '/',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.mainSubnetIpv4.prefix;
    const currVal_1:any = co.mainSubnetIpv4.prefix_len;
    ck(v,3,0,currVal_0,currVal_1);
  });
}
function View_VMDashboardComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'td',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'src',
        '../../assets/images/icons/gears.png'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Twój serwer jest w trakcie konfigurowania'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    ']))
  ]
  ,(null as any),(null as any));
}
function View_VMDashboardComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',[[
        'style',
        'padding-bottom:2px'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zasilanie'])),
    (l()(),import0.ɵted((null as any),['\n                                    ']))
  ]
  ,(null as any),(null as any));
}
function View_VMDashboardComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov((<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent),26).open()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Restart']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.checkingStatus;
    ck(v,0,0,currVal_0);
  });
}
function View_VMDashboardComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'td',[[
        'style',
        'padding:0px !important'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),1).open()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.refreshPowerStatus()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Odśwież stan'])),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_12)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = true;
    ck(v,11,0,currVal_3);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.checkingStatus;
    ck(v,4,0,currVal_0);
    const currVal_1:any = ((co.powerStatus == (null as any))? 'Czekaj...': ((co.powerStatus == 'running')? 'Wyłącz': 'Włącz'));
    ck(v,5,0,currVal_1);
    const currVal_2:any = co.checkingStatus;
    ck(v,7,0,currVal_2);
  });
}
function View_VMDashboardComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',[[
        'style',
        'padding-bottom:2px'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            Karta zarządzająca\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    ']))
  ]
  ,(null as any),(null as any));
}
function View_VMDashboardComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'td',[[
        'style',
        'padding:0px !important'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-short-plus'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.getConsoleLink()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                Otwórz konsolę\n                                            '])),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-short-plus'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showLoginInformation(import0.ɵnov((<any>(<any>v.parent).parent),54))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                Dane logowania\n                                            '])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    ']))
  ]
  ,(null as any),(null as any));
}
function View_VMDashboardComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '(',
      ')'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.subnetIPv4s.length;
    ck(v,1,0,currVal_0);
  });
}
function View_VMDashboardComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tr',[[
        'class',
        'standard noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'td',[
      [
        'class',
        'text-center'
      ]
      ,
      [
        'colspan',
        '5'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'src',
        '../../assets/images/icons/network.png'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brak adresacji dodatkowej dla tego serwera'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    ']))
  ]
  ,(null as any),(null as any));
}
function View_VMDashboardComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'tr',([] as any[]),[[
        8,
        'className',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                            ',
      ' / ',
      '\n                                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[' '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showIPS(v.context.$implicit,import0.ɵnov((<any>(<any>v.parent).parent),104))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                Szczegóły\n                                            '])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',v.context.$implicit.type,'');
    ck(v,0,0,currVal_0);
    const currVal_1:any = v.context.$implicit.prefix;
    const currVal_2:any = v.context.$implicit.prefix_len;
    ck(v,3,0,currVal_1,currVal_2);
    const currVal_3:any = co.ipMethods.fromPrefixLen(v.context.$implicit.prefix_len);
    ck(v,6,0,currVal_3);
    const currVal_4:any = co.getServerGateway(v.context.$implicit.ipv4s);
    ck(v,9,0,currVal_4);
    const currVal_5:any = v.context.$implicit.translations.subnet_type;
    ck(v,12,0,currVal_5);
  });
}
function View_VMDashboardComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),155,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_8)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),94,'div',[[
        'class',
        'row-taller'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),91,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),89,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),87,'tr',[[
        'class',
        'noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),39,'td',[[
        'class',
        'text-top width-half'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zarządzanie'])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),33,'table',[[
        'class',
        'standard noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),12,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'status-indicator'
      ]
      ],[[
        2,
        'active',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Stan:\n                                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_9)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_10)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_11)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_13)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_14)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    \n                                    \n                                '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),43,'td',[
      [
        'class',
        'text-top width-half'
      ]
      ,
      [
        'style',
        'padding-left: 10px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Adresacja IP '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_15)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),32,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),18,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),15,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Podsieć/IP'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Maska'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brama'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Typ'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_16)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),3,(null as any),View_VMDashboardComponent_17)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵpod([
      'itemsPerPage',
      'currentPage'
    ]
    ),
    import0.ɵpid(0,import4.PaginatePipe,[import4.PaginationService]),
    (l()(),import0.ɵted((null as any),['\n                                   \n                                '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'pagination-controls',[
      [
        'directionLinks',
        'true'
      ]
      ,
      [
        'nextLabel',
        'Następne'
      ]
      ,
      [
        'previousLabel',
        'Poprzednie'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'pageChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pageChange' === en)) {
        const pd_0:any = ((<any>(co.p = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_PaginationControlsComponent_0,import5.RenderType_PaginationControlsComponent)),
    import0.ɵdid(49152,(null as any),0,import4.PaginationControlsComponent,([] as any[]),{
      directionLinks: [
        0,
        'directionLinks'
      ]
      ,
      previousLabel: [
        1,
        'previousLabel'
      ]
      ,
      nextLabel: [
        2,
        'nextLabel'
      ]

    }
    ,{pageChange: 'pageChange'}),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),24,'div',[[
        'class',
        'row-taller'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),19,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'tr',[[
        'class',
        'noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'td',[[
        'class',
        'text-top width-half'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['vCPU:'])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'style',
        'width: 100%;'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'td',[
      [
        'class',
        'text-top width-half'
      ]
      ,
      [
        'style',
        'padding-left: 10px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['vRAM:'])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'style',
        'width: 100%;'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),24,'div',[[
        'class',
        'row-taller'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),19,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'tr',[[
        'class',
        'noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'td',[[
        'class',
        'text-top width-half'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dysk:'])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'style',
        'width: 100%;'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'td',[
      [
        'class',
        'text-top width-half'
      ]
      ,
      [
        'style',
        'padding-left: 10px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Sieć:'])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'style',
        'width: 100%;'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.mainSubnetIpv4;
    ck(v,5,0,currVal_0);
    const currVal_3:boolean = !co.VMIsReady;
    ck(v,39,0,currVal_3);
    const currVal_4:any = co.VMIsReady;
    ck(v,42,0,currVal_4);
    const currVal_5:any = co.VMIsReady;
    ck(v,45,0,currVal_5);
    const currVal_6:any = co.VMIsReady;
    ck(v,48,0,currVal_6);
    const currVal_7:any = co.VMIsReady;
    ck(v,51,0,currVal_7);
    const currVal_8:any = (co.subnetIPv4s && co.subnetIPv4s.length);
    ck(v,61,0,currVal_8);
    const currVal_9:boolean = !co.subnetIPv4s.length;
    ck(v,88,0,currVal_9);
    const currVal_10:any = import0.ɵunv(v,91,0,import0.ɵnov(v,93).transform(co.subnetIPv4s,ck(v,92,0,5,co.p)));
    ck(v,91,0,currVal_10);
    const currVal_11:any = 'true';
    const currVal_12:any = 'Poprzednie';
    const currVal_13:any = 'Następne';
    ck(v,98,0,currVal_11,currVal_12,currVal_13);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (co.powerStatus == 'running');
    ck(v,28,0,currVal_1);
    const currVal_2:any = (co.VMIsReady? ((co.powerStatus == 'running')? 'WŁĄCZONY': 'WYŁĄCZONY'): 'W PRZYGOTOWYWANIU');
    ck(v,31,0,currVal_2);
    const currVal_14:any = import0.ɵinlineInterpolate(1,'',co.rrdCpu,'');
    ck(v,116,0,currVal_14);
    const currVal_15:any = import0.ɵinlineInterpolate(1,'',co.rrdRam,'');
    ck(v,124,0,currVal_15);
    const currVal_16:any = import0.ɵinlineInterpolate(1,'',co.rrdDisk,'');
    ck(v,142,0,currVal_16);
    const currVal_17:any = import0.ɵinlineInterpolate(1,'',co.rrdNet,'');
    ck(v,150,0,currVal_17);
  });
}
function View_VMDashboardComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['SSH RSA PUBKEY'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,[[
        'textarea',
        1
      ]
    ],(null as any),1,'textarea',[
      [
        'readonly',
        ''
      ]
      ,
      [
        'rows',
        '4'
      ]
      ,
      [
        'style',
        'width: 100%;'
      ]

    ]
      ,[[
        8,
        'placeholder',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',(co.isLoadingAccountData? 'Ładowanie...': ''),'');
    ck(v,7,0,currVal_0);
    const currVal_1:any = co.accountPubKey;
    ck(v,8,0,currVal_1);
  });
}
function View_VMDashboardComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.ip_address;
    ck(v,3,0,currVal_0);
    const currVal_1:any = v.context.$implicit.ip_type;
    ck(v,6,0,currVal_1);
  });
}
function View_VMDashboardComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'pagination-controls',[
      [
        'class',
        'nowrap'
      ]
      ,
      [
        'directionLinks',
        'true'
      ]
      ,
      [
        'id',
        'ips'
      ]
      ,
      [
        'nextLabel',
        'Następne'
      ]
      ,
      [
        'previousLabel',
        'Poprzednie'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'pageChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pageChange' === en)) {
        const pd_0:any = ((<any>(co.p2 = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_PaginationControlsComponent_0,import5.RenderType_PaginationControlsComponent)),
    import0.ɵdid(49152,(null as any),0,import4.PaginationControlsComponent,([] as any[]),{
      id: [
        0,
        'id'
      ]
      ,
      directionLinks: [
        1,
        'directionLinks'
      ]
      ,
      previousLabel: [
        2,
        'previousLabel'
      ]
      ,
      nextLabel: [
        3,
        'nextLabel'
      ]

    }
    ,{pageChange: 'pageChange'}),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'ips';
    const currVal_1:any = 'true';
    const currVal_2:any = 'Poprzednie';
    const currVal_3:any = 'Następne';
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
function View_VMDashboardComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),151,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    Cloud.VPS: ',
      '\n                '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'options blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_5)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),31,'div',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),28,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),26,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),24,'tr',[[
        'class',
        'noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'td',[[
        'class',
        'text-top width-half'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Informacje:'])),
    (l()(),import0.ɵted((null as any),[
      '\n                        vCPU: ',
      ''
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        vRAM: ',
      ' GB'
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        \n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'td',[
      [
        'class',
        'text-top width-half'
      ]
      ,
      [
        'style',
        'padding-left: 10px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        Dysk główny: ',
      ''
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        Podpięte dyski: '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_6)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        Prędkość łącza publicznego: ',
      ' Mbit/s\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_7)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),48,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]

    ]
    ,(null as any),(null as any),(null as any),import6.View_Modal_0,import6.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'accountDataModal',
        4
      ]
      ],0,import7.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),0,5,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalHeader_0,import6.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import7.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dane dostępowe'])),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),1,33,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalContent_0,import6.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import7.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,12,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Login '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,[[
        'login',
        1
      ]
    ],(null as any),0,'input',[
      [
        'readonly',
        ''
      ]
      ,
      [
        'style',
        'width: 100%;'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
      ,[[
        8,
        'value',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'input-button'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(212992,(null as any),0,import8.ClipboardDirective,[
      import0.ElementRef,
      import9.NotificationsService
    ]
      ,{elt: [
        0,
        'elt'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,12,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Hasło'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,[[
        'password',
        1
      ]
    ],(null as any),0,'input',[
      [
        'readonly',
        ''
      ]
      ,
      [
        'style',
        'width: 100%;'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        8,
        'value',
        0
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'input-button'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(212992,(null as any),0,import8.ClipboardDirective,[
      import0.ElementRef,
      import9.NotificationsService
    ]
      ,{elt: [
        0,
        'elt'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_VMDashboardComponent_18)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),2,2,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalFooter_0,import6.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import7.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),47,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]

    ]
    ,(null as any),(null as any),(null as any),import6.View_Modal_0,import6.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'IPSModalData',
        4
      ]
      ],0,import7.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),0,9,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalHeader_0,import6.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import7.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),0,5,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    Adresy podsieci ',
      ''
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    Maska podsieci: ',
      ''
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    Brama podsieci: ',
      '\n                '
    ]
    )),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),1,28,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalContent_0,import6.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import7.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,21,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Adres IP'])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Type'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),3,(null as any),View_VMDashboardComponent_19)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵpod([
      'id',
      'itemsPerPage',
      'currentPage',
      'totalItems'
    ]
    ),
    import0.ɵpid(0,import4.PaginatePipe,[import4.PaginationService]),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted(0,['\n\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_VMDashboardComponent_20)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n               \n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),2,2,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalFooter_0,import6.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import7.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.VMIsReady;
    ck(v,13,0,currVal_1);
    const currVal_5:any = co.additionalDisks;
    ck(v,43,0,currVal_5);
    const currVal_7:any = co.VMIsReady;
    ck(v,51,0,currVal_7);
    const currVal_8:any = 'Zamknij';
    ck(v,54,0,currVal_8);
    const currVal_10:any = import0.ɵnov(v,73);
    ck(v,76,0,currVal_10);
    const currVal_13:any = import0.ɵnov(v,87);
    ck(v,90,0,currVal_13);
    const currVal_14:any = co.hasPubKey;
    ck(v,95,0,currVal_14);
    const currVal_15:any = 'Zamknij';
    ck(v,104,0,currVal_15);
    const currVal_19:any = import0.ɵunv(v,137,0,import0.ɵnov(v,139).transform(co.getModalElements(),ck(v,138,0,'ips',5,co.p2,co.getModalElements().length)));
    ck(v,137,0,currVal_19);
    const currVal_20:any = (co.getModalElements().length > 5);
    ck(v,144,0,currVal_20);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.vm.name;
    ck(v,7,0,currVal_0);
    const currVal_2:any = co.vm.processors;
    ck(v,28,0,currVal_2);
    const currVal_3:any = co.vm.ram_size;
    ck(v,30,0,currVal_3);
    const currVal_4:any = co.diskSize;
    ck(v,39,0,currVal_4);
    const currVal_6:any = co.vm.public_network_speed;
    ck(v,45,0,currVal_6);
    const currVal_9:any = import0.ɵinlineInterpolate(1,'',co.accountLogin,'');
    ck(v,73,0,currVal_9);
    const currVal_11:any = import0.ɵinlineInterpolate(1,'',(co.isLoadingAccountData? 'Ładowanie...': ''),'');
    const currVal_12:any = import0.ɵinlineInterpolate(1,'',(!co.isLoadingAccountData? co.accountPassword: ''),'');
    ck(v,87,0,currVal_11,currVal_12);
    const currVal_16:any = co.modalElements.prefix;
    ck(v,110,0,currVal_16);
    const currVal_17:any = co.ipMethods.fromPrefixLen(co.modalElements.prefix_len);
    ck(v,112,0,currVal_17);
    const currVal_18:any = co.getServerGateway(co.modalElements.ipv4s);
    ck(v,114,0,currVal_18);
  });
}
function View_VMDashboardComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'empty-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'src',
        '../../assets/images/icons/gears.png'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Twój Cloud.VPS jest w trakcie konfigurowania'])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(null as any));
}
function View_VMDashboardComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_4)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_21)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.VMIsReady && !co.loadingVMData);
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.VMIsReady;
    ck(v,6,0,currVal_1);
  },(null as any));
}
export function View_VMDashboardComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),23,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]

    ]
    ,(null as any),(null as any),(null as any),import6.View_Modal_0,import6.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'powerModal',
        4
      ]
      ],0,import7.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),0,5,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalHeader_0,import6.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import7.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uwaga!'])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),1,5,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalContent_0,import6.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import7.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'Czy na pewno chcesz ',
      ' Cloud.VPS?'
    ]
    )),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),2,5,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalFooter_0,import6.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import7.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.VMDashboardComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.powerVM(((co.powerStatus == 'running')? 'shutdown': 'start'),import0.ɵnov(v,1))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n\n'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),23,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]

    ]
    ,(null as any),(null as any),(null as any),import6.View_Modal_0,import6.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'restartModal',
        4
      ]
      ],0,import7.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),0,5,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalHeader_0,import6.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import7.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uwaga!'])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),1,5,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalContent_0,import6.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import7.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Czy na pewno chcesz zrestartować Cloud.VPS?'])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),2,5,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import6.View_ModalFooter_0,import6.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import7.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_VMDashboardComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n\n\n\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_VMDashboardComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import10.VMDashboardComponent = v.component;
    const currVal_0:any = 'Zamknij';
    ck(v,1,0,currVal_0);
    const currVal_4:any = 'Zamknij';
    ck(v,26,0,currVal_4);
    const currVal_5:any = (co.powerStatus == 'running');
    ck(v,46,0,currVal_5);
    const currVal_6:any = co.loadingVMData;
    ck(v,51,0,currVal_6);
    const currVal_7:boolean = !co.loadingVMData;
    ck(v,54,0,currVal_7);
  },(ck,v) => {
    var co:import10.VMDashboardComponent = v.component;
    const currVal_1:any = ((co.powerStatus == 'running')? 'wyłączyć': 'włączyć');
    ck(v,14,0,currVal_1);
    const currVal_2:any = co.checkingStatus;
    ck(v,20,0,currVal_2);
    const currVal_3:any = ((co.powerStatus == (null as any))? 'Czekaj...': ((co.powerStatus == 'running')? 'Wyłącz': 'Włącz'));
    ck(v,21,0,currVal_3);
  });
}
function View_VMDashboardComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-backupftp-dashboard',([] as any[]),(null as any),(null as any),(null as any),View_VMDashboardComponent_0,RenderType_VMDashboardComponent)),
    import0.ɵdid(114688,(null as any),0,import10.VMDashboardComponent,[
      import11.ApiService,
      import12.ResponseService,
      import13.ActivatedRoute,
      import14.BreadcrumbService,
      import13.Router
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const VMDashboardComponentNgFactory:import0.ComponentFactory<import10.VMDashboardComponent> = import0.ɵccf('app-backupftp-dashboard',import10.VMDashboardComponent,View_VMDashboardComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/vm/vm-dashboard.component.ngfactory.ts